import { eraseCookie, getCookie, setCookie } from "~/hooks/filterCookie";
import { IIvideonLocalCredentials } from "~/services/ivideon/model";

const COOKIE_KEY = "ivideon_credentials";

export const setIvideonCredentials = (
  credentials: IIvideonLocalCredentials
) => {
  const existingCredentials = getIvideonCredentials();
  const updatedCredentials = existingCredentials.some(
    (existingCredential) => existingCredential.DealerId === credentials.DealerId
  )
    ? existingCredentials.map((credential) =>
        credential.DealerId === credentials.DealerId ? credentials : credential
      )
    : [...existingCredentials, credentials];
  setCookie(COOKIE_KEY, JSON.stringify(updatedCredentials), 120);
};

export const destroyIvideonCredentials = () => {
  eraseCookie(COOKIE_KEY);
};

export const removeIvideonCredential = (api_host: string) => {
  const existingCredentials = getIvideonCredentials();
  const updatedCredentials = existingCredentials.filter(
    (credential) => credential.api_host !== api_host
  );
  setCookie(COOKIE_KEY, JSON.stringify(updatedCredentials), 120);
};

export const getIvideonCredentials = (): IIvideonLocalCredentials[] => {
  const credentials = getCookie(COOKIE_KEY);
  return credentials ? JSON.parse(credentials) : [];
};
